import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import config from "../../config";
import { useSelector } from "react-redux";
import {
  Form,
  Input,
  Button,
  Select,
  Row,
  Col,
  Popconfirm,
  theme,
  Dropdown,
  Cascader,
  App,
} from "antd";
import { makeStyles } from "@material-ui/core/styles";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { startCase } from "lodash";
import CustomTabs from "../tabs";
import CustomTable from "../table";
import { RiDeleteBin6Line, RiEditLine } from "react-icons/ri";
import { EllipsisOutlined } from "@ant-design/icons";
import {
  employeeAccessOptions,
  restaurantAccess,
} from "../../utils/accessOptions";

const useStyles = makeStyles((theme) => ({
  formInput: {
    border: "1px solid #000",
    borderRadius: 8,
  },
  formItem: {
    fontWeight: 700,
    "& .ant-col ant-col-24 ant-form-item-label": {
      padding: 0,
    },
  },
  tabs: {
    "& .css-1h9z7r5-MuiButtonBase-root-MuiTab-root.Mui-selected": {
      background: "#FFFFFF !important",
    },
    "& button": {
      padding: "1.5rem 2rem",
    },
  },
}));

const EmployeeAccess = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("1");
  const [accessArray, setAccessArray] = useState([
    { name: "Generate bill – Reprint Bill", value: "generateReprintBill" },
    { name: "Cancel bill and stock returns", value: "cancelBill" },
    { name: "Manage customers", value: "customerManagement" },
    {
      name: "Add products to inventory, manage inventory",
      value: "inventoryManagement",
    },
    { name: "Edit product pricing", value: "editProductPrice" },
    { name: "Reward and redeem loyalty", value: "rewardRedeemLoyalty" },
    { name: "View reports and dashboard", value: "reportsAndDashboard" },
    { name: "Vendor Management", value: "vendorManagement" },
    { name: "Expense Management", value: "expensesManagement" },
  ]);
  var shopDetails = useSelector((state) => state.shopDetails);
  const {
    token: { colorPrimary, colorTextSecondary },
  } = theme.useToken();

  const [employeeArr, setEmployeeArr] = useState([]);
  const [addEmployeeModal, setAddEmployeeModal] = useState(false);
  const { message } = App.useApp();
  const [empId, setEmpId] = useState("");
  const [employeeData, setEmployeeData] = useState({});
  const [selectedAccess, setSelectedAccess] = useState([]);
  const [editAccessModal, setEditAccessModal] = useState(false);
  const [designationModal, setDesignationModal] = useState(false);
  const [tagModal, setTagModal] = useState(false);

  const [tagArray, setTagArray] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [activeKey, setActiveKey] = useState(0);
  const [initialValue, setInitialValue] = useState({});
  const [mode, setMode] = useState("add");
  const [designation, setDesignation] = useState("");
  const [designationName, setDesignationName] = useState("");
  const [addDesignationLoading, setAddDesignationLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({});

  const classes = useStyles();

  const handleCheckBoxChange = (data) => {
    var tempArr = selectedAccess;
    if (tempArr.includes(data)) {
      tempArr = tempArr.filter((d) => d !== data);
    } else {
      tempArr.push(data);
    }
    setSelectedAccess([...tempArr]);
  };

  const accessDataConverter = (data) => {
    console.log("data999", data);
    if (data)
      if (Object.keys(data).length !== 0) {
        let dataToDisplay = [];
        data?.forEach((i) => {
          i.access?.forEach((item) => {
            item.access?.forEach((j) => {
              if (j === true) {
                let tempArray = [i.field, item.field];
                dataToDisplay.push(tempArray);
              } else {
                let tempArray = [i.field, item.field, j];
                dataToDisplay.push(tempArray);
              }
            });
          });
        });
        return dataToDisplay;
      }
  };

  const accessDataConvertToAdd = (unifiedAccess) => {
    let tempArray = [];
    unifiedAccess.forEach((data) => {
      const index = tempArray.findIndex((obj) => obj.field === data[0]);
      if (index !== -1) {
        const tempData = tempArray[index];

        tempData.access?.forEach((obj) => {
          if (obj.field === data[1]) {
            const indexAccess = tempData.access.findIndex(
              (obj) => obj.field === data[1]
            );
            let tempAccess = tempData.access;
            if (indexAccess !== -1) {
              tempAccess.splice(indexAccess, 1);
            }

            let temp = [];
            temp = obj.access;
            temp.push(data[2]);
            const tempObj = {
              field: tempData.field,
              access: [
                ...tempAccess,
                {
                  field: obj.field,
                  access: temp,
                },
              ],
            };
            tempArray.splice(index, 1);
            tempArray.push(tempObj);
          } else {
            const tempObj = {
              field: tempData.field,
              access: [
                ...tempData.access,
                {
                  field: data[1],
                  access: [data[2] || true],
                },
              ],
            };

            tempArray.splice(index, 1);
            tempArray.push(tempObj);
          }
        });
      } else {
        const tempObj = {
          field: data[0],
          access: [
            {
              field: data[1],
              access: [data[2] || true],
            },
          ],
        };
        tempArray.push(tempObj);
      }
    });
    return tempArray;
  };

  const addEmployee = async (value) => {
    console.log("value", value);
    let tempArray = accessDataConvertToAdd(value.unifiedAccess);
    try {
      var res = await fetch(
        `${config.newApiGateway}/employe/createEmployee-fetchEmployee`,
        {
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            action: "createEmployee",
            ownerShopId: shopDetails.shopId,
            employeePhoneNumber: `${shopDetails.country.dialCode}${value.employeePhoneNumber}`,
            employeeName: value.employeeName,
            access: {
              pos: tempArray,
            },
            designation: value.employeeDesignation,
            assignedTag: value.userTag || "",
            ...(["Outlet"].includes(shopDetails.userType) && {
              parentShopId: shopDetails.ownerShopId,
            }),
          }),
          method: "POST",
        }
      );
      res = await res.json();
      if (res.code === "SUCCESS") {
        message.success(res.message);
        setAddEmployeeModal(false);
        alert(res.message);
        fetchEmployee();
      } else {
        alert(res.message);
      }
    } catch (err) {
      console.log("Err", err);
    }
  };

  useEffect(() => {
    // if (shopDetails.shopId && shopDetails.empId)
    //   props.history.push("/dashboard/overview");
    if (shopDetails.shopId) {
      fetchEmployee();
      fetchTags();
      fetchDesignation();
    }
    if (shopDetails?.shopType === "Restaurant") {
      var checker = accessArray.filter((data) => data.value === "subscription");
      if (checker.length > 0) return;
      setAccessArray([
        ...accessArray,
        { name: "Create and manage subscriptions.", value: "subscription" },
        { name: "Manage your restaurant KOT.", value: "kotDisplay" },
      ]);
    }
  }, [shopDetails]);

  console.log("designationList", designationList);

  // ShortCutKey
  useEffect(() => {
    function keydownHandler(event) {
      if (event.altKey && event.keyCode == 65) {
        //  Add Employee (A)
        setAddEmployeeModal(true);
      } else if (event.altKey && event.keyCode == 83) {
        // Search (S)tableSearchSelect
        let input = document.querySelector(".MuiInputBase-input");
        if (input) input.focus();
      }
    }
    document.addEventListener("keydown", keydownHandler);
    return () => {
      window.removeEventListener("keydown", keydownHandler);
    };
  });

  const fetchEmployee = async () => {
    try {
      var res = await fetch(
        `${config.newApiGateway}/employe/createEmployee-fetchEmployee`,
        {
          method: "post",
          body: JSON.stringify({
            shopId: shopDetails.shopId,
            action: "fetchEmployee",
          }),
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
        }
      );
      res = await res.json();
      if (res.code === "SUCCESS") {
        setLoading(false);
        setEmployeeArr(res.data);
      } else {
        setLoading(false);
        alert(res.message);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const fetchTags = async () => {
    console.log("Fetch shopId", shopDetails.shopId);
    try {
      var res = await fetch(`${config.newApiGateway}/employe/tagsforEmployee`, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: "fetch",
          shopId: shopDetails.shopId,
        }),
      });
      res = await res.json();
      console.log("Fetch REs", res);
      if (res.code === "ERROR") {
        console.log("Err", res);
        return;
      }
      console.log();
      setTagArray(res.data);
    } catch (err) {
      console.log("Err", err);
    }
  };
  const fetchDesignation = async () => {
    try {
      var res = await fetch(
        `${config.newApiGateway}/employe/employee-designation`,
        {
          method: "post",
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "fetch",
            shopId: shopDetails.shopId,
          }),
        }
      );
      res = await res.json();
      console.log("Fetch REs", res);
      if (res.code === "ERROR") {
        console.log("Err", res);
        return;
      }
      console.log();
      setDesignationList(res.data);
    } catch (err) {
      console.log("Err", err);
    }
  };

  const addTags = async (value) => {
    const isExist = tagArray.some(
      (i) => i.tagName.toLowerCase() === value.tagName.toLowerCase()
    );
    if (isExist) {
      return alert("Tag already exists!!");
    }
    try {
      setAddDesignationLoading(true);
      var res = await fetch(`${config.newApiGateway}/employe/tagsforEmployee`, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: "add",
          tagName: value.tagName,
          shopId: shopDetails.shopId,
        }),
      });
      res = await res.json();
      if (res.code === "ERROR") {
        console.log("Add Err", res.data);
        return alert(res.message);
      }
      alert(res.message);
      form.resetFields();
      fetchTags();
    } catch (err) {
      console.log("Err", err);
    } finally {
      setAddDesignationLoading(false);
    }
  };

  const deleteTag = async (id) => {
    try {
      var res = await fetch(`${config.newApiGateway}/employe/tagsforEmployee`, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: "delete",
          tagId: id,
          shopId: shopDetails.shopId,
        }),
      });
      res = await res.json();
      if (res.code === "ERROR") {
        return alert(res.message);
      }
      fetchTags();
    } catch (err) {
      console.log("Err", err);
    }
  };

  const editEmployee = (values) => {
    let tempArray = accessDataConvertToAdd(values.unifiedAccess);
    removeEmployee(
      initialValues,
      "update",
      tempArray,
      values.employeeDesignation,
      values.userTag
    );
  };

  const removeEmployee = async (
    data,
    type,
    access = [],
    designation,
    selectedTag
  ) => {
    try {
      var res = await fetch(
        `${config.newApiGateway}/employe/remove-editrole-employee`,
        {
          method: "post",
          body: JSON.stringify({
            empId: data.userId,
            type: type,
            access: {
              pos: access,
            },
            ...(type === "update" && { assignedTag: selectedTag, designation }),
          }),
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
        }
      );
      res = await res.json();
      if (res.code === "SUCCESS") {
        message.success(res.message);
        setEditAccessModal(false);
        fetchEmployee();
      } else {
        console.log("Lambda error", res.data);
        alert(res.message);
      }
    } catch (err) {
      console.log("Err", err);
      alert("Something went wrong. Please try again.");
    } finally {
      setInitialValues({});
      form.resetFields();
    }
  };

  const handleDesignationSubmit = async (v) => {
    let payload = {};
    if (!designationName.trim() || !designationName) {
      return alert("Enter the designation");
    }
    setAddDesignationLoading(true);
    if (mode === "add") {
      payload = {
        type: "add",
        shopId: shopDetails.shopId,
        designationName: designationName,
      };
    } else if (mode === "edit") {
      payload = {
        type: "edit",
        designationId: initialValue.designationId,
        shopId: shopDetails.shopId,
        ...v,
      };
    }
    try {
      const response = await fetch(
        `${config.newApiGateway}/employe/employee-designation`,
        {
          body: JSON.stringify(payload),
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-type": "application/json",
          },
          method: "POST",
        }
      );

      const res = await response.json();
      if (res.code === "SUCCESS") {
        fetchDesignation();
        setDesignationName("");
        setMode("add");
        setDesignationModal(false);
        setAddDesignationLoading(false);
      } else {
        console.log("Lambda error", res.data);
        alert(res.message);
      }
    } catch (err) {
      console.log("employeeDesignation", err);
    } finally {
      setAddDesignationLoading(false);
    }
  };

  const menuItems = (data) => {
    return [
      {
        key: "1",
        icon: <RiDeleteBin6Line color={colorPrimary} />,
        label: (
          <Popconfirm
            title="Delete the task"
            description="Are you sure to remove this Employee?"
            onConfirm={() => removeEmployee(data, "remove")}
            onCancel={() => {}}
            okText={"Yes"}
            cancelText={"No"}
          >
            <span
              style={{
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 4,
                color: colorPrimary,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Remove
            </span>
          </Popconfirm>
        ),
        style: {
          width: 100,
        },
      },
      {
        key: "2",
        icon: <RiEditLine color={colorTextSecondary} />,
        style: {
          width: 100,
        },
        label: (
          <span
            style={{
              fontSize: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              gap: 4,
              color: colorTextSecondary,
              fontWeight: 600,
            }}
            role="button"
            onClick={() => {
              setEditAccessModal(!editAccessModal);
              setInitialValues(data);
              form.setFieldsValue({
                unifiedAccess: accessDataConverter(data.unifiedAccess?.pos),
                userTag: data.assignedTag,
                employeeDesignation: data.userDesignation,
              });
            }}
          >
            Edit
          </span>
        ),
      },
    ];
  };

  const handleEdit = (rowData) => {
    setDesignationName(rowData.designationName);
    setMode("edit");
    setInitialValue({
      designationId: rowData.designationId,
      designationName: rowData.designationName,
    });
    setDesignationModal(true);
  };
  const tabs = [
    {
      key: "1",
      label: `Employees Details`,
    },
    {
      key: "2",
      label: `Designation & Tags`,
    },
  ];
  const columns = [
    {
      dataIndex: "userName",
      title: "Employee name",
    },
    {
      dataIndex: "userPhoneNumber",
      title: "Phone number",
    },
    {
      title: "Designation",
      render: (rowData) => {
        const getData = designationList.find(
          (i) => i.designationId === rowData.userDesignation
        );
        return getData ? startCase(getData.designationName) : "-";
      },
    },
    {
      title: "Actions",
      render: (data) => {
        return (
          <Dropdown
            getPopupContainer={(el) => el.parentNode}
            menu={{ items: menuItems(data) }}
            placement="left"
            arrow
          >
            <EllipsisOutlined
              style={{
                fontSize: "2rem",
                transform: "rotate(90deg)",
                cursor: "pointer",
                padding: "0.5rem",
              }}
            />
          </Dropdown>
        );
      },
    },
  ];
  const designationColums = [
    {
      title: "Designation Title",
      render: (rowDate) => {
        return <div>{rowDate.designationName}</div>;
      },
    },
    {
      title: "Action",
      render: (rowDate) => {
        return (
          <Button onClick={() => handleEdit(rowDate)} type="primary">
            Edit
          </Button>
        );
      },
    },
  ];

  useEffect(() => {
    if (shopDetails.shopType === "Restaurant") {
      employeeAccessOptions.forEach((i) => {
        if (i.value === "generateBill") {
          i.children = [
            ...i.children,
            {
              label: "Print KOT",
              value: "printKOT",
            },
          ];
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <App>
      <CustomTabs
        items={tabs}
        activeKey={activeTab}
        onTabChange={(v) => setActiveTab(v)}
        style={{
          marginBottom: 20,
        }}
      />
      {activeTab === "1" && (
        <CustomTable
          columns={columns}
          data={employeeArr}
          title={"Employee Details"}
          extraAction={
            <Button type="primary" onClick={() => setAddEmployeeModal(true)}>
              Add Employee
            </Button>
          }
          loading={loading}
          emptyContainerStyle={{
            height: "calc(100vh - 320px)",
          }}
          style={{
            minHeight: "calc(100vh - 365px)",
          }}
        />
      )}
      {activeTab === "2" && (
        <Row gutter={[20, 0]}>
          <Col span={16}>
            <CustomTable
              columns={designationColums}
              data={designationList}
              title={"Designations"}
              extraAction={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <Button
                    type="primary"
                    onClick={() => {
                      setMode("add");
                      setDesignationModal(true);
                    }}
                  >
                    Create Designation
                  </Button>
                </div>
              }
              emptyContainerStyle={{
                height: "calc(100vh - 320px)",
              }}
              style={{
                minHeight: "calc(100vh - 365px)",
              }}
            />
          </Col>
          <Col span={8}>
            <CustomTable
              columns={[
                {
                  title: "Tag Name",
                  dataIndex: "tagName",
                  render: (tagName) => (
                    <span
                      style={{
                        textTransform: "capitalize",
                        display: "inline-block",
                        padding: 4,
                      }}
                    >
                      {tagName}
                    </span>
                  ),
                },
              ]}
              data={tagArray}
              title={"Tags"}
              extraAction={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <Button type="primary" onClick={() => setTagModal(true)}>
                    Create Tag
                  </Button>
                </div>
              }
              emptyContainerStyle={{
                height: "calc(100vh - 320px)",
              }}
              style={{
                minHeight: "calc(100vh - 365px)",
              }}
            />
          </Col>
        </Row>
      )}
      <Modal show={tagModal} centered>
        <Modal.Header>
          <h4>Manage Tags</h4>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Form
              labelCol={{
                span: 24,
              }}
              wrapperCol={{
                span: 24,
              }}
              onFinish={addTags}
              form={form}
            >
              <Form.Item
                name="tagName"
                label="Enter Tag name"
                rules={[
                  {
                    required: true,
                    message: "Please enter tag name",
                  },
                ]}
              >
                <Input type="text" placeholder="Enter Tag Name" size="middle" />
              </Form.Item>
              <Button
                type="primary"
                size="middle"
                style={{
                  borderRadius: "8px",
                  backgroundColor: "#EF4667",
                  color: "#fff",
                  float: "right",
                }}
                htmlType="submit"
                disabled={addDesignationLoading}
              >
                Add Tag
              </Button>
            </Form>
          </div>
          <div style={{ marginTop: "70px" }}>
            {tagArray.map((data) => (
              <div
                key={data.tagId}
                style={{
                  padding: "8px",
                  float: "left",
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{
                    border: "1px solid grey",
                    padding: "8px 10px 2px 10px",
                    borderRadius: "17px",
                  }}
                >
                  <label>{data.tagName}</label>
                  <HighlightOffIcon
                    style={{
                      marginLeft: "10px",
                      cursor: "pointer",
                      color: "red",
                    }}
                    onClick={() => deleteTag(data.tagId)}
                  />
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-danger"
            size="sm"
            onClick={() => setTagModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={addEmployeeModal}
        centered
        onHide={() => {
          setEmployeeData({});
          setSelectedAccess([]);
          setEmpId("");
          setAddEmployeeModal(false);
        }}
        size="lg"
      >
        <Modal.Header>
          <h5>Add Employee of your shop</h5>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Form
              labelCol={{
                span: 24,
              }}
              wrapperCol={{
                span: 24,
              }}
              onFinish={addEmployee}
            >
              <Row gutter={[16, 0]}>
                <Col span={12}>
                  <Form.Item
                    name="employeePhoneNumber"
                    label="Enter Employee Phone number"
                    rules={[
                      {
                        required: true,
                        message: "Please enter employee phone number",
                      },
                      {
                        pattern: /^[0]?[56789]\d{9}$/,
                        message: "Please enter a valid phone number!",
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      placeholder="Enter Employee phone number"
                      size="middle"
                    />
                  </Form.Item>
                  <Form.Item
                    label="Employee Name"
                    name="employeeName"
                    rules={[
                      {
                        required: true,
                        message: "Please input your employee name!",
                      },
                    ]}
                  >
                    <Input placeholder="Enter Employee Name" size="middle" />
                  </Form.Item>
                  <Form.Item
                    name="employeeDesignation"
                    label="Select the Designation"
                    rules={[
                      {
                        required: true,
                        message: "Please select the designation",
                      },
                    ]}
                  >
                    <Select placeholder="Select the designation">
                      {designationList.map((i) => {
                        return (
                          <Select.Option value={i.designationId}>
                            {startCase(i.designationName)}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Choose Tag" name="userTag">
                    <Select placeholder="Choose tag(optional)">
                      {tagArray.map((data) => (
                        <Select.Option key={data.tagId} name={data.tagId}>
                          {data.tagName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    rules={[
                      {
                        required: true,
                        message: "Please select access",
                      },
                    ]}
                    label="Access"
                    name="unifiedAccess"
                  >
                    <Cascader
                      style={{
                        width: "100%",
                      }}
                      options={[...employeeAccessOptions, ...restaurantAccess]}
                      placeholder="Choose access"
                      multiple
                      maxTagCount="responsive"
                      expandTrigger="click"
                      showCheckedStrategy={Cascader.SHOW_CHILD}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Button
                type="primary"
                size="large"
                style={{
                  borderRadius: "8px",
                  backgroundColor: "#EF4667",
                  color: "#fff",
                  float: "right",
                }}
                htmlType="submit"
              >
                Add Employee
              </Button>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={editAccessModal}
        centered
        onHide={() => {
          setEditAccessModal(false);
          form.resetFields();
        }}
        dialogClassName="customEmployeeModal"
      >
        <Modal.Header>
          <h5>Edit access</h5>
        </Modal.Header>
        <Modal.Body>
          <Form
            labelCol={{
              span: 24,
            }}
            wrapperCol={{
              span: 24,
            }}
            form={form}
            onFinish={editEmployee}
          >
            <Form.Item
              name="employeeDesignation"
              label="Select the Designation"
              rules={[
                {
                  required: true,
                  message: "Please select the designation",
                },
              ]}
            >
              <Select placeholder="Select the designation">
                {designationList.map((i) => {
                  return (
                    <Select.Option value={i.designationId}>
                      {startCase(i.designationName)}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item label="Choose Tag" name="userTag">
              <Select placeholder="Choose tag(optional)">
                {tagArray.map((data) => (
                  <Select.Option
                    value={data.tagId}
                    key={data.tagId}
                    name={data.tagId}
                  >
                    {data.tagName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please select access",
                },
              ]}
              label="Access"
              name="unifiedAccess"
            >
              <Cascader
                style={{
                  width: "100%",
                }}
                options={[...employeeAccessOptions, ...restaurantAccess]}
                placeholder="Choose access"
                multiple
                maxTagCount="responsive"
                expandTrigger="click"
                allowClear={false}
                showCheckedStrategy={Cascader.SHOW_CHILD}
              />
            </Form.Item>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-warning"
            onClick={() => {
              setSelectedAccess([]);
              setDesignation("");
              setEmployeeData({});
              setEditAccessModal(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              form.submit();
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={designationModal}
        centered
        onHide={() => {
          setDesignationModal(false);
          setDesignationName("");
        }}
        dialogClassName="customEmployeeModal"
      >
        <Modal.Header>
          <h5>{mode === "edit" ? "Edit" : "Create"} designation</h5>
        </Modal.Header>
        <Modal.Body>
          <Form
            labelCol={{
              span: 24,
            }}
            wrapperCol={{
              span: 24,
            }}
          >
            <Form.Item label="Designation" name="designationName">
              <Input
                type="text"
                size="middle"
                defaultValue={designationName}
                placeholder="Enter the Designation"
                onChange={(v) => setDesignationName(v.target.value)}
              />
            </Form.Item>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-warning"
            onClick={() => {
              setDesignationModal(false);
              setDesignationName("");
            }}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              const isExist = designationList.some(
                (i) =>
                  i.designationName.toLowerCase() ===
                  designationName.toLowerCase()
              );
              if (isExist) {
                return alert("Designation already exists!!");
              }
              handleDesignationSubmit({ designationName });
            }}
            disabled={addDesignationLoading}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </App>
  );
};
export default EmployeeAccess;
